import { render, staticRenderFns } from "./central.vue?vue&type=template&id=0d2a95aa&scoped=true&lang=pug"
import script from "./central.vue?vue&type=script&lang=js"
export * from "./central.vue?vue&type=script&lang=js"
import style0 from "./central.vue?vue&type=style&index=0&id=0d2a95aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a95aa",
  null
  
)

export default component.exports